/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdLabel } from './IdLabel';
import {
    IdLabelFromJSON,
    IdLabelFromJSONTyped,
    IdLabelToJSON,
    IdLabelToJSONTyped,
} from './IdLabel';
import type { GroupContractType } from './GroupContractType';
import {
    GroupContractTypeFromJSON,
    GroupContractTypeFromJSONTyped,
    GroupContractTypeToJSON,
    GroupContractTypeToJSONTyped,
} from './GroupContractType';
import type { GroupContractSubscriberDto } from './GroupContractSubscriberDto';
import {
    GroupContractSubscriberDtoFromJSON,
    GroupContractSubscriberDtoFromJSONTyped,
    GroupContractSubscriberDtoToJSON,
    GroupContractSubscriberDtoToJSONTyped,
} from './GroupContractSubscriberDto';

/**
 * 
 * @export
 * @interface GroupContractItemDto
 */
export interface GroupContractItemDto {
    /**
     * 
     * @type {string}
     * @memberof GroupContractItemDto
     */
    id: string;
    /**
     * Identifier of the contract. Null for drafts without any tunnel.
     * @type {string}
     * @memberof GroupContractItemDto
     */
    contractIdentifier?: string | null;
    /**
     * Localized status label (FR libellé), for display only.
     * @type {string}
     * @memberof GroupContractItemDto
     */
    status: string;
    /**
     * Stable status code (Codes.StatutsContrats — "B" draft, "EC" active...), for front logic.
     * @type {string}
     * @memberof GroupContractItemDto
     */
    statusCode?: string | null;
    /**
     * Main due date pre-formatted in French (e.g. "01 janvier"). Null if not set.
     * @type {string}
     * @memberof GroupContractItemDto
     */
    mainDueDate?: string | null;
    /**
     * Raw day of the main due date.
     * @type {number}
     * @memberof GroupContractItemDto
     */
    mainDueDateDay?: number | null;
    /**
     * Raw month of the main due date.
     * @type {number}
     * @memberof GroupContractItemDto
     */
    mainDueDateMonth?: number | null;
    /**
     * Owner / propriétaire (legal entity designation).
     * @type {string}
     * @memberof GroupContractItemDto
     */
    owner?: string | null;
    /**
     * Subscriber name (no fallback on owner). Null if not set.
     * @type {string}
     * @memberof GroupContractItemDto
     */
    subscriberName?: string | null;
    /**
     * True if contract type is CADRE (kept for API backward compatibility)
     * @type {boolean}
     * @memberof GroupContractItemDto
     */
    isMaster: boolean;
    /**
     * Portée du contrat — PersonneMorale = contrat de cabinet (vendu par le cabinet créateur), Plateforme = contrat de la plateforme (créé par la PM principale ou le back-office, vendu par les courtiers habilités). Le back accepte encore l'ancien nom "Organisation" en entrée mais ne l'écrit plus.
     * 
     * @type {string}
     * @memberof GroupContractItemDto
     */
    scope?: GroupContractItemDtoScopeEnum;
    /**
     * Products covered by the contract (derived from active tunnels, deduplicated).
     * @type {Array<IdLabel>}
     * @memberof GroupContractItemDto
     */
    products?: Array<IdLabel>;
    /**
     * 
     * @type {GroupContractType}
     * @memberof GroupContractItemDto
     */
    type?: GroupContractType;
    /**
     * 
     * @type {string}
     * @memberof GroupContractItemDto
     */
    plateformeId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractItemDto
     */
    plateformeName?: string;
    /**
     * 
     * @type {GroupContractSubscriberDto}
     * @memberof GroupContractItemDto
     */
    subscriber?: GroupContractSubscriberDto;
    /**
     * True if the contract was created by a broker (CreateurCourtierId set)
     * @type {boolean}
     * @memberof GroupContractItemDto
     */
    isBrokerOwned?: boolean;
    /**
     * ID of the broker who created the contract (null = admin contract)
     * @type {string}
     * @memberof GroupContractItemDto
     */
    creatorBrokerId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractItemDto
     */
    creationTime: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractItemDto
     */
    lastModificationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupContractItemDto
     */
    quotesCount: number;
    /**
     * 
     * @type {number}
     * @memberof GroupContractItemDto
     */
    activeContractsCount: number;
}


/**
 * @export
 */
export const GroupContractItemDtoScopeEnum = {
    PersonneMorale: 'PersonneMorale',
    Plateforme: 'Plateforme'
} as const;
export type GroupContractItemDtoScopeEnum = typeof GroupContractItemDtoScopeEnum[keyof typeof GroupContractItemDtoScopeEnum];


/**
 * Check if a given object implements the GroupContractItemDto interface.
 */
export function instanceOfGroupContractItemDto(value: object): value is GroupContractItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('isMaster' in value) || value['isMaster'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('quotesCount' in value) || value['quotesCount'] === undefined) return false;
    if (!('activeContractsCount' in value) || value['activeContractsCount'] === undefined) return false;
    return true;
}

export function GroupContractItemDtoFromJSON(json: any): GroupContractItemDto {
    return GroupContractItemDtoFromJSONTyped(json, false);
}

export function GroupContractItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupContractItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contractIdentifier': json['contractIdentifier'] == null ? undefined : json['contractIdentifier'],
        'status': json['status'],
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'mainDueDate': json['mainDueDate'] == null ? undefined : json['mainDueDate'],
        'mainDueDateDay': json['mainDueDateDay'] == null ? undefined : json['mainDueDateDay'],
        'mainDueDateMonth': json['mainDueDateMonth'] == null ? undefined : json['mainDueDateMonth'],
        'owner': json['owner'] == null ? undefined : json['owner'],
        'subscriberName': json['subscriberName'] == null ? undefined : json['subscriberName'],
        'isMaster': json['isMaster'],
        'scope': json['scope'] == null ? undefined : json['scope'],
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(IdLabelFromJSON)),
        'type': json['type'] == null ? undefined : GroupContractTypeFromJSON(json['type']),
        'plateformeId': json['plateformeId'] == null ? undefined : json['plateformeId'],
        'plateformeName': json['plateformeName'] == null ? undefined : json['plateformeName'],
        'subscriber': json['subscriber'] == null ? undefined : GroupContractSubscriberDtoFromJSON(json['subscriber']),
        'isBrokerOwned': json['isBrokerOwned'] == null ? undefined : json['isBrokerOwned'],
        'creatorBrokerId': json['creatorBrokerId'] == null ? undefined : json['creatorBrokerId'],
        'creationTime': json['creationTime'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'quotesCount': json['quotesCount'],
        'activeContractsCount': json['activeContractsCount'],
    };
}

export function GroupContractItemDtoToJSON(json: any): GroupContractItemDto {
    return GroupContractItemDtoToJSONTyped(json, false);
}

export function GroupContractItemDtoToJSONTyped(value?: GroupContractItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'contractIdentifier': value['contractIdentifier'],
        'status': value['status'],
        'statusCode': value['statusCode'],
        'mainDueDate': value['mainDueDate'],
        'mainDueDateDay': value['mainDueDateDay'],
        'mainDueDateMonth': value['mainDueDateMonth'],
        'owner': value['owner'],
        'subscriberName': value['subscriberName'],
        'isMaster': value['isMaster'],
        'scope': value['scope'],
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(IdLabelToJSON)),
        'type': GroupContractTypeToJSON(value['type']),
        'plateformeId': value['plateformeId'],
        'plateformeName': value['plateformeName'],
        'subscriber': GroupContractSubscriberDtoToJSON(value['subscriber']),
        'isBrokerOwned': value['isBrokerOwned'],
        'creatorBrokerId': value['creatorBrokerId'],
        'creationTime': value['creationTime'],
        'lastModificationTime': value['lastModificationTime'],
        'quotesCount': value['quotesCount'],
        'activeContractsCount': value['activeContractsCount'],
    };
}

